import { render } from "./remove.bulk.station.modal.vue?vue&type=template&id=2857cf06&ts=true"
import script from "./remove.bulk.station.modal.vue?vue&type=script&lang=ts"
export * from "./remove.bulk.station.modal.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__